<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="姓名" prop="realName">
                <a-input v-model="queryParam.realName" placeholder="请输入姓名" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="昵称" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入昵称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="身份证号" prop="idCard">
                <a-input v-model="queryParam.idCard" placeholder="请输入身份证号" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="状态" prop="status">
                <a-select v-model="queryParam.status" placeholder="请选择状态" allow-clear>
                  <a-select-option :value="1">待审核</a-select-option>
                  <a-select-option :value="2">通过</a-select-option>
                  <a-select-option :value="3">拒绝</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:authentication:add']">-->
        <!--          <a-icon type="plus" />新增-->
        <!--        </a-button>-->
        <!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:authentication:edit']">-->
        <!--          <a-icon type="edit" />修改-->
        <!--        </a-button>-->
        <!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:authentication:remove']">-->
        <!--          <a-icon type="delete" />删除-->
        <!--        </a-button>-->
        <!--        <a-button type="primary" @click="handleExport" v-hasPermi="['user:authentication:export']">-->
        <!--          <a-icon type="download" />导出-->
        <!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />

      <div style="float: right;font-size:20px;margin-right: 10px">
        <a-tag color="pink" style="font-size: 20px" >总计：{{this.authenticationTotal.all}}</a-tag>
        <a-tag color="orange" style="font-size: 20px" >待审核：{{this.authenticationTotal.one}}</a-tag>
        <a-tag color="green" style="font-size: 20px" >已拒绝：{{this.authenticationTotal.two}}</a-tag>
<!--        <a-tag color="cyan" style="font-size: 20px" >日活用户量：{{1}}</a-tag>-->
      </div>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
           <a v-if="record.status == 1 || record.status == 3" @click="updateStatus(record,2)">
            <a-icon type="edit" />通过
          </a>
          <a v-if="record.status == 1 || record.status == 2" @click="updateStatus(record,3)">
            <a-icon type="edit" />拒绝
          </a>
          <a-divider type="vertical"/>
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['user:authentication:edit']">
            <a-icon type="edit" />编辑
          </a>
<!--          <a-divider type="vertical" v-hasPermi="['user:authentication:remove']" />-->
<!--          <a @click="handleDelete(record)" v-hasPermi="['user:authentication:remove']">-->
<!--            <a-icon type="delete" />删除-->
<!--          </a>-->
        </span>
          <img v-viewer :key="record.idCardFront" style="width: 48px;height: 48px;" :src="record.idCardFront" slot="idCardFront" slot-scope="text, record">
          <img v-viewer :key="record.idCardReverse" style="width: 48px;height: 48px;" :src="record.idCardReverse" slot="idCardReverse" slot-scope="text, record">
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {
  pageAuthentication,
  delAuthentication,
  queryAuthenticationCount, updateAuthentication
} from '@/api/user/authentication'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import Vue from 'vue'
Vue.use(VueViewer)
// 设置初始值
VueViewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})
export default {
  name: 'Authentication',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      authenticationTotal: null,
      // 查询参数
      queryParam: {
        userId: null,
        realName: null,
        nickname: null,
        idCard: null,
        idCardFront: null,
        idCardReverse: null,
        status: null,
        refuseReason: null,
        cateName: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '用户id',
          dataIndex: 'userId',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '用户昵称',
          dataIndex: 'nickname',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '手机号',
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '姓名',
          dataIndex: 'realName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '身份证',
          dataIndex: 'idCard',
          align: 'center'
        },
        {
          title: '身份证正面',
          dataIndex: 'idCardFront',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'idCardFront'}

        },
        {
          title: '身份证反面',
          dataIndex: 'idCardReverse',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'idCardReverse'}

        },
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          customRender: function (state) {
            if (state === 1) {
              return '待审核'
            } else if (state === 2) {
              return '已通过'
            } else if (state === 3) {
              return '已拒绝'
            }
          }
        },
        {
          title: '拒绝原因',
          dataIndex: 'refuseReason',
          ellipsis: true,
          align: 'center',
          customRender: function (text) {
            if (text) {
              return text
            } else {
              return '-'
            }
          }
        },
        {
          title: '申请时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询用户认证列表 */
    getList () {
      this.loading = true
      queryAuthenticationCount().then(response => {
        this.authenticationTotal = response.data
      })
      pageAuthentication(this.queryParam).then(response => {
        debugger
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    updateStatus(record, status) {
      record.status = status
      updateAuthentication(record).then(response => {
        this.$message.success(
          '修改成功',
          3
        )
        this.$emit('ok')
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        realName: undefined,
        idCard: undefined,
        idCardFront: undefined,
        idCardReverse: undefined,
        status: undefined,
        refuseReason: undefined,
        cateName: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delAuthentication(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('user/authentication/export', {
            ...that.queryParam
          }, `用户认证_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
